import {
  SET_VIRTUAL_MIRROR_SCRIPTS_LOADED_STATUS,
  SET_VIRTUAL_MIRROR_VISIBILITY,
} from './mutations'

export const ACTION_SET_VIRTUAL_MIRROR_SCRIPTS_LOADED_STATUS =
  'ACTION_SET_VIRTUAL_MIRROR_SCRIPTS_LOADED_STATUS'
export const ACTION_SET_VIRTUAL_MIRROR_VISIBILITY = 'ACTION_SET_VIRTUAL_MIRROR_VISIBILITY'

export const actions = {
  [ACTION_SET_VIRTUAL_MIRROR_SCRIPTS_LOADED_STATUS]: function ({ commit }, payload) {
    commit(SET_VIRTUAL_MIRROR_SCRIPTS_LOADED_STATUS, payload)
  },
  [ACTION_SET_VIRTUAL_MIRROR_VISIBILITY]: function ({ commit }, payload) {
    commit(SET_VIRTUAL_MIRROR_VISIBILITY, payload)
  },
}
